var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchedulesicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 52.22,
    x2: 297.78,
    y1: 132.81,
    y2: 132.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3250fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9e70ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2aceeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cbf38"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bcbec0",
    d: "M56.83 134.19H284c3.1 0 6.16.05 9.25 0h.39a4.21 4.21 0 0 0 4.14-4.14V87.71A10.91 10.91 0 0 0 287.05 77h-34.83V61.55c0-4.33-3.81-8.47-8.28-8.28a8.42 8.42 0 0 0-8.28 8.28V77H114.78V61.55c0-4.33-3.8-8.47-8.27-8.28a8.41 8.41 0 0 0-8.28 8.28V77H65.3a16.17 16.17 0 0 0-5.27.53 10.9 10.9 0 0 0-7.34 10.4v42.12a4.21 4.21 0 0 0 4.14 4.14zM297.73 244.49v-87.93H52.64v126.35c0 1.16-.06 2.35 0 3.5.3 6.08 5.29 10.3 11.23 10.33h222.71A10.91 10.91 0 0 0 297.73 286c.11-4.06 0-8.14 0-12.23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#a)",
    strokeMiterlimit: 10,
    strokeWidth: 17.5,
    d: "M52.22 132.81h245.56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulesicon);
export default __webpack_public_path__ + "static/media/schedulesicon.15a96eabcfd9da144618466f2807f0c3.svg";
export { ForwardRef as ReactComponent };